export default {
  bind (el, binding, vnode) {
    vnode['context'].documentHandler = (e) => {
      if (el.contains(e.target)) {
        return false
      }
      if (binding.expression) {
        vnode['context'][binding.expression]()
      }
    }
    document.addEventListener('click', vnode['context'].documentHandler)
  },
  unbind (el, binding, vnode) {
    document.removeEventListener('click', vnode['context'].documentHandler)
  }
}



// WEBPACK FOOTER //
// ./src/directive/clickoutside.js